<template>
  <div>
    <Header></Header>
    <div class="index-body about-body">
        <div class="banner">
          <div class="title wrapper-box">
            <img src="../../../static/img/web_img/title_about.png" />
          </div>
        </div>
        <div class="info">
          <img class="show" src="../../../static/img/web_img/img_about1.png"/>
          <img class="hide" src="../../../static/img/web_img/img_shu.png"/>
        </div>
        <div class="title-dsj">
          <img src="../../../static/img/web_img/title_dasj.png"/>
        </div>
        <div class="list wrapper-box">
          <div class="item">
            <h2>2014年成立 </h2>
            <p>在美东地区建设了第一个仓库，为跨境电商提供专业物流服务</p>
          </div>
          <div class="item">
            <h2>2016年8月</h2>
            <p>美西波特兰仓库投入运营</p>
          </div>
          <div class="item">
            <h2>2018年6月</h2>
            <p>全美直营网点超过十个，服务美东西两岸，和菜鸟网络多家3PL服务商展开独家合作，为用户提供可溯源的国际物流服务</p>
          </div>
          <div class="item">
            <h2>2020年8月</h2>
            <p>海外仓业务上线，立志成为移库换标、退货管理、质检等第三方服务的领先企业</p>
          </div>
          <div class="item">
            <h2>2021年6月</h2>
            <p>实时库存数突破50万件，累积出库数量超过100万件</p>
          </div>
          <div class="line"></div>
        </div>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped src="../../../static/css/enter/main.scss"></style>
<style lang="scss" scoped src="../../../static/css/enter/media.scss"></style>


// WEBPACK FOOTER //
// src/pages/web/aboutus.vue